import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  TextField,
  Tooltip,
  IconButton,
  MenuItem,
  Typography,
} from "@material-ui/core";
import FilterIcon from "mdi-material-ui/FilterOutline";
import RefreshIcon from "mdi-material-ui/Refresh";
import HorizontalCards from "../../../../components/HorizontalCardList/HorizontalCards";

const C13DeliveryOrdersStatusDashboardFilter = (props) => {
  return (
    <Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
        }}
      >
        <div>
          <Typography variant="h5" color="primary" style={{ fontWeight: 700 }}>
            All Orders Progress
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "70%",
            justifyContent: "flex-end",
          }}
        >
          <div>
            <Tooltip title="Refresh Orders Data">
              <IconButton
                style={{ marginLeft: "-10px" }}
                onClick={() => props.getOrdersData()}
              >
                <RefreshIcon fontSize="default" color="primary" />
              </IconButton>
            </Tooltip>
          </div>
         
        </div>

         
      </div>
    </Fragment>
  );
};

C13DeliveryOrdersStatusDashboardFilter.propTypes = {
  state: PropTypes.object,
  handleChange: PropTypes.func,
  handleToggleTableFilter: PropTypes.func,
  onNewItemButtonClick: PropTypes.func,
  getOrdersData: PropTypes.func,
};

C13DeliveryOrdersStatusDashboardFilter.defaultProps = {
  state: {},
  handleChange: (fn) => fn,
  handleToggleTableFilter: (fn) => fn,
  onNewItemButtonClick: (fn) => fn,
  getOrdersData: (fn) => fn,
};

export default C13DeliveryOrdersStatusDashboardFilter;
